import React from 'react';
import { format, differenceInCalendarDays } from 'date-fns';
import CoursePartials from 'Components/Card/Partials/Partials.Course';
import EventPartials from 'Components/Card/Partials/Partials.Event';
import { StatusCheckmarkInfo, StatusTriangleWarn } from 'Components/StatusMessage';
import { getUTCDateFromServerDate } from 'utils/dateUtils';

const ScheduleCoursePartials = {
    VoucherContent: ({voucherExpirationDate}) =>  (
        <StatusTriangleWarn>
            Voucher expires {format(voucherExpirationDate, "MMM dd, yyyy")} - {differenceInCalendarDays(voucherExpirationDate, Date.now())} days remaining
        </StatusTriangleWarn>
    ),
    CompleteContent: ({completionDate}) => (
        <StatusCheckmarkInfo>
            Completed {format(completionDate, "MMM dd")}
        </StatusCheckmarkInfo>
    ),
    AuditContent: () => (
        <StatusTriangleWarn>
            <div>Audit Needed
                <span style={{textTransform: "none", display: "block", marginTop: "0.25rem"}}>Please fill out the audit form so the instructor may verify your attendance.</span>
            </div>
        </StatusTriangleWarn>
    ),
    CardLink: CoursePartials.CardLink,
    CourseLaunchBtn: ({course}) => {
        const displayProps = {
            startDate: getUTCDateFromServerDate(course.UpcomingClassStart), 
            endDate: getUTCDateFromServerDate(course.UpcomingClassEnd), 
            beforeEventText: course.ActionLink.CardLinkText,
            afterEventText: course.ActionLink.CardLinkText,
            duringEventText: "Launch Class"
        };

        return (
            <EventPartials.EventLaunchBtn href={course.ActionLink.CardLinkUri}>
                <EventPartials.EventLaunchBtnContent {...displayProps} />
            </EventPartials.EventLaunchBtn>
        );
    },
    ScheduleCourseEventDisplay: (props) => {
        //local var(s)
        const { course, children } = props;
        const displayProps = { 
            startDate: getUTCDateFromServerDate(course.UpcomingClassStart), 
            endDate: getUTCDateFromServerDate(course.UpcomingClassEnd), 
            eventTitle: course.UpcomingClassTitle 
        };

        //render
        return (
            <EventPartials.EventDisplay {...displayProps} >
                {children}
            </EventPartials.EventDisplay>
        );
    }
};



export default ScheduleCoursePartials;